import {
	UpdateProjectMutationVariables,
	useCloneProjectMutation,
	useCreateProjectMutation,
	useDeleteProjectMutation,
	useUpdateProjectMutation
} from 'graphql/generated';

export const useProjectController = () => {
	const [updateProject] = useUpdateProjectMutation();
	const [createProject] = useCreateProjectMutation();
	const [cloneProject] = useCloneProjectMutation();
	const [deleteProject] = useDeleteProjectMutation();

	const handleClone = async (
		id: string,
		values: any,
		callback: Function | null = null
	) => {
		const result = await cloneProject({
			variables: {
				id,
				...values
			}
		});
		if (callback) callback(result?.data?.cloneProject?.id);

		return result?.data?.cloneProject?.id;
	};

	const handleCreate = async (values, callback: Function | null = null) => {
		const result = await createProject({
			variables: {
				...values
			}
		});

		

		// Create tags

		if (callback) callback(result?.data?.createProject?.id);
		return result?.data?.createProject?.id;
	};

	const handleUpdate = async (id: string, values) => {
		let newValues: UpdateProjectMutationVariables = { id };

		if (values.name != undefined) newValues.name = values.name;
		if (values.baselineScenarioDescription != undefined)
			newValues.baselineScenarioDescription =
				values.baselineScenarioDescription;
		if (values.baselineScenarioImpacts != undefined)
			newValues.baselineScenarioImpacts = values.baselineScenarioImpacts;

		const result = await updateProject({
			variables: {
				...newValues
			},
			update(cache) {
				let fields = {};

				if (newValues.name !== undefined)
					fields.name = () => newValues.name;
				if (newValues.baselineScenarioDescription !== undefined)
					fields.baselineScenarioDescription = () =>
						newValues.baselineScenarioDescription;
				if (newValues.baselineScenarioImpacts !== undefined)
					fields.baselineScenarioImpacts = () =>
						newValues.baselineScenarioImpacts;

				cache.modify({
					id: `Project:${id}`,
					fields
				});
			},
			optimisticResponse: {
				updateProject: true
			}
		});
	};

	const handleDelete = async (
		id: string,
		callback: Function | null = null
	) => {
		if (id == null) {
			return;
		}

		await deleteProject({
			variables: { id }
		});

		if (callback) callback();
	};

	return {
		createProject: handleCreate,
		updateProject: handleUpdate,
		cloneProject: handleClone,
		deleteProject: handleDelete
	};
};
